<template>
  <div class="grid-1">
    <div class="fixed top-0 right-0 w-full h-full">
      <div
        class="bg w-full h-full duration-700"
        :style="`background-image: url(${img})`"
      >
        <div class="h-full g-center bg-slate-800 text-white bg-opacity-60">
          <div class="grid-1 text-center">
            <h1 class="font-medium uppercase text-xl tracking-widest mb-6">
              {{ $t("start.title") }}
            </h1>
            <p class="w-6/12 text-sm m-auto pb-12">
              {{ $t("start.dis") }}
            </p>
            <button-app
              @action="$router.push('/')"
              :text="$t('start.button')"
              svg="cart"
              theme="btnD w-4/12"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buttonApp from "@/components/buttonApp.vue";

export default {
  beforeCreate() {
    localStorage.start ? this.$router.push("/") : (localStorage.start = true);
  },
  components: { buttonApp },
  data() {
    return {
      img: "https://bit.ly/3NNkK9Z",
    };
  },
  created() {
    let imgs = [
      "https://bit.ly/3RnB98q",
      "https://bit.ly/3ABJGyn",
      "https://bit.ly/3RiTzH6",
      "https://bit.ly/3NNkK9Z",
    ];
    let count = 0;
    setInterval(() => {
      this.img = imgs[count];
      count = count == imgs.length - 1 ? 0 : count + 1;
    }, 5000);
  },
};
</script>
